<script>
export default {
	methods: {
		async getPreview(videoSrc, lg = false) {

			if (!videoSrc || typeof videoSrc !== 'string' || (!this.isYouTubeUrl(videoSrc) && !this.isRutubeUrl(videoSrc))) {
				return "https://img.youtube.com/vi/OHQzOanoAec/maxresdefault.jpg"
			}

			if (this.isYouTubeUrl(videoSrc)) {
				const regex = /embed\/([a-zA-Z0-9_-]+)/;
				const match = videoSrc.match(regex);

				if (match && match[1]) {
					const videoId = match[1];
					const thumbnailUrlBig = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
					const thumbnailUrlMid = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;
					const thumbnailUrlMid2 = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
					const thumbnailUrlMid3 = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
					const thumbnailUrlSmall = `https://img.youtube.com/vi/${videoId}/default.jpg`;

					if (lg) {
						const dimensions1 = await this.getImageDimensions(thumbnailUrlBig);
						if (dimensions1.width === 120 && dimensions1.height === 90) {
							const dimensions2 = await this.getImageDimensions(thumbnailUrlMid);
							if (dimensions2.width === 120 && dimensions2.height === 90) {
								const dimensions3 = await this.getImageDimensions(thumbnailUrlMid2);
								if (dimensions3.width === 120 && dimensions3.height === 90) {
									const dimensions4 = await this.getImageDimensions(thumbnailUrlMid3);
									if (dimensions4.width === 120 && dimensions4.height === 90) {
										return thumbnailUrlSmall;
									}
									return thumbnailUrlMid3;
								}
								return thumbnailUrlMid2;
							}
							return thumbnailUrlMid;
						}
						return thumbnailUrlBig;
					} else {
						const dimensions2 = await this.getImageDimensions(thumbnailUrlMid);
						if (dimensions2.width === 120 && dimensions2.height === 90) {
							const dimensions3 = await this.getImageDimensions(thumbnailUrlMid2);
							if (dimensions3.width === 120 && dimensions3.height === 90) {
								return thumbnailUrlSmall;
							}
							return thumbnailUrlMid2;
						}
						return thumbnailUrlMid;
					}
				}
			}

			if (this.isRutubeUrl(videoSrc)) {
				const regex = /video\/([a-z0-9]+)/i;
				const match = videoSrc.match(regex);
				if (match && match[1]) {
					const videoId = match[1];
					return `https://rutube.ru/api/video/${videoId}/thumbnail/?redirect=1`
				}

				return 'https://img.youtube.com/vi/OHQzOanoAec/maxresdefault.jpg';
			}
		},

		isYouTubeUrl(url) {
			const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
			return youtubeRegex.test(url);
		},

		isRutubeUrl(url) {
			const rutubeRegex = /^(https?:\/\/)?(www\.)?(rutube\.ru)\/video\/.+$/;
			return rutubeRegex.test(url);
		},

		async getImageDimensions(url) {
			return new Promise((resolve, reject) => {
				const img = new Image();
				img.src = url;

				img.onload = () => {
					resolve({width: img.width, height: img.height});
				};

				img.onerror = () => {
					reject(new Error('Не удалось загрузить изображение'));
				};
			});
		}
	}
};
</script>
